import { default as ctx } from "axios";
import getCurrentEnv from '../data/utils/getCurrentEnv';
import data from "../data/env.config.json";
import activityTracker from '../utils/activityTracker';

// Initialize base URL
ctx.defaults.baseURL = data[getCurrentEnv()].api_url;

// Token acquisition handler for MSAL (to be set by the application)
let getTokenHandler = null;

// Export function to set the token handler from MSAL context
export const setMsalTokenHandler = (handler) => {
  getTokenHandler = handler;
};

// Add a request interceptor
ctx.interceptors.request.use(
  async function (config) {
    // Get token from MSAL cache securely (no sessionStorage usage)
    let token = null;
    if (getTokenHandler) {
      try {
        token = await getTokenHandler();
      } catch (error) {
        console.error('[Axios] Failed to acquire token from MSAL:', error);
        // Continue without token; backend will handle 401
      }
    }
    
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Store request start time for tracking
    config.metadata = { startTime: new Date() };

    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
ctx.interceptors.response.use(
  function (response) {
    // Track successful API call
    const { config } = response;
    if (config && config.metadata) {
      activityTracker.trackAPICall(
        config.method?.toUpperCase() || 'GET',
        config.url || 'unknown',
        response.status,
        config.metadata.startTime
      );
    }

    // response.status = 403;
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Track failed API call
    const { config, response } = error;
    if (config && config.metadata) {
      activityTracker.trackAPICall(
        config.method?.toUpperCase() || 'GET',
        config.url || 'unknown',
        response?.status || 'ERROR',
        config.metadata.startTime
      );
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    if (response) {
      const { data, status } = response;

      // show error toast — skip 423 (lock conflict), handled by lockList() in OverviewTable
      if (data && status !== 423) {
        import("./../utils/error/handleError").then((module) =>
          module.default(data)
        );
      }

      if (status) {
        const code = parseInt(status);
        if ([401, 403, 500, 504].includes(code)) {
          import("./../utils/error/redirectError").then((module) =>
            module.default(code)
          );
        }
      }
    }

    return Promise.reject(error);
  }
);

export const setAxiosBaseURL = (gateway) => {
  ctx.defaults.baseURL = data[getCurrentEnv()].api_url;
};

export default ctx;
